<template>
  <history
    :text="this.$route.query.text"
    :searchIndex="this.$route.query.searchIndex"
    :searchTips="tips"
    :searchLink="link"
    :id="id"
    :hotType="this.$route.query.hotType"
  />
</template>
<script>
import history from "../../components/contents/searchCommon/history.vue";
// 接口
import API from "@/utils/axiosApi/searchApi";
import { log } from "console";
export default {
  components: {
    history,
  },
  data() {
    return {
      tips: "",
      link: "",
      id: "", //记录搜索次数
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //获取后台返的底纹数据
    getTipsData() {
      API.getShading({}, (res) => {
        if (res.code == 200) {
          this.tips = res.data == null ? "开始搜索，从新妈变星妈" :res.data.searchContent;
          this.link = res.data.searchLink
          this.id = res.data.id
        }else{
          this.tips = "开始搜索，从新妈变星妈"
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$route.query.powderedMilkIndex == "powderedMilk") {
      localStorage.setItem("powderedMilkIndex", "powderedMilk");
    } else {
      localStorage.removeItem("powderedMilkIndex");
    }
    if (sessionStorage.getItem('searchVal') == "powderedMilk") {
        this.tips = "简单一搜，找到你要的奶粉知识";
    }else{
      this.getTipsData(); //获取后台拿到的底纹数据方法
    }

  },
};
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
</style>